import * as THREE from 'three';

/**
 * Camera preset configurations for snapshot capture
 * 
 * ⚠️ IMPORTANT: Do NOT set rotation here.
 * Rotations are derived via camera.lookAt(0,0,0) at capture time.
 * The rotation values visible in the Three.js editor UI are OUTPUT values
 * (what the camera's matrix ends up being), not INPUT values you can feed
 * into camera.rotation.set() — doing so produces incorrect results because
 * Three.js recalculates the matrix from position + lookAt, not raw Euler angles.
 */

// 3D Perspective View Camera Preset
// Camera sits at equal X/Y distance, Z=0, looking toward origin for angled 3D view
export const SNAPSHOT_3D = {
  position: new THREE.Vector3(0, 0, 150),
  fov: 50,
  lookAt: new THREE.Vector3(0, 0, 0),
};

// 2D Orthographic / Top-Down View Camera Preset
// Camera sits almost directly above (Y=50) with slight X/Z offset, looking down at origin
export const SNAPSHOT_2D = {
  position: new THREE.Vector3(0, 0, 50),
  frustumSize: 50,  // Half-height of orthographic frustum in world units
  lookAt: new THREE.Vector3(0, 0, 0),
};

// Snapshot configuration
export const SNAPSHOT_CONFIG = {
  defaultScale: 2,        // 2x supersampling for proposal quality
  maxScale: 3,            // 3x for A4 print quality
  format: 'image/png',
  filenamePrefix: 'solar-design',
  restoreDelayMs: 50,     // ms to wait before restoring live view
};
